<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-buyer /></span>
          <span>{{ capitalize($t('names.buyer', { n: 2 })) }}</span>
          <span class="text-muted mx-2">{{ DASH }}</span>
          <span class="icon"><icon-colored-dsp /></span>
          <span>{{ capitalize($t('messages.dspOrExchange')) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content pad-top">
          <div class="row">
            <div
              v-if="deal.buyerOrganizationDSPIDs.length > 0"
              class="col-12">
              <table
                class="table buyer-org-dsps-table"
                :aria-label="i18n.global.t('names.buyer', { n: 2 })">
                <colgroup>
                  <col width="50%" />
                  <col width="50%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>{{ $t('names.buyer', { n: 1 }) }}</th>
                    <th>{{ $t('messages.dspOrExchange') }}</th>
                  </tr>
                </thead>
                <tbody v-if="packageBuyerOrganizationDSPs.length > 0">
                  <tr
                    v-for="(x, i) in packageBuyerOrganizationDSPs"
                    :key="i">
                    <td>
                      <div
                        v-if="x.organization.logoUrl !== null"
                        class="org-logo-container">
                        <img
                          class="org-logo"
                          :src="x.organization.logoUrl"
                          :alt="x.organization.name" />
                      </div>
                      <span v-else>{{ x.organization.name }}</span>
                      <span
                        v-if="isExternalDeal"
                        class="seat-id badge badge-default-hollow"
                        >{{ capitalize($t('names.seatID', { n: 1 })) }}: {{ x.seatID }}
                      </span>
                    </td>
                    <td>
                      <div
                        v-if="x.dsp.logoUrl !== null"
                        class="org-logo-container">
                        <img
                          class="org-logo"
                          :src="x.dsp.logoUrl"
                          :alt="x.dsp.name" />
                      </div>
                      <span v-else>{{ x.dsp.name }}</span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr
                    v-for="i in deal.buyerOrganizationDSPIDs.length"
                    :key="i">
                    <td>
                      <table-column-loader height="7rem" />
                    </td>
                    <td>
                      <table-column-loader height="7rem" />
                    </td>
                  </tr>
                </tbody>
              </table>

              <input
                id="package_details_buyer_restrictions_value"
                type="hidden"
                aria-hidden="true"
                :value="deal.buyerOrganizationDSPIDs.join(',')" />
            </div>
            <div
              v-else
              class="col-12">
              {{ formattedBuyersLabel }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { capitalize, computed } from 'vue';

  import TableColumnLoader from '@/common/components/controls/table/TableColumnLoader.vue';
  import { IconColoredBuyer, IconColoredDsp } from '@/common/icons/colored';
  import { Package } from '@/common/models';
  import OrganizationDSP from '@/common/models/misc-api-models/OrganizationDSP';
  import { DASH } from '@/globals';
  import i18n from '@/vueI18n';

  interface IDealDetailsDSPsAndBuyersProps {
    deal: Package;
    isExternalDeal: boolean;
    packageBuyerOrganizationDSPs: OrganizationDSP[];
  }

  const props = defineProps<IDealDetailsDSPsAndBuyersProps>();

  const formattedBuyersLabel = computed(() => {
    if (props.deal?.isPGDeal || props.deal?.hasCadencePurchaseType || props.deal.isPreferredOrNGInternalDeal) {
      return capitalize(i18n.global.t('messages.allBuyers'));
    }
    if (props.deal.isNGExternalOrPreferredExternalDeal) {
      return capitalize(i18n.global.t('messages.allExternalBuyers'));
    }
    return DASH;
  });
</script>

<style lang="scss" scoped>
  .org-logo-container {
    margin: 1.6rem;
    height: 6.4rem;
    display: flex;
    align-items: center;
    flex-direction: row;

    .org-logo {
      display: block;
      max-height: 6.4rem;
      max-width: 100%;
    }
  }
</style>
